var capDesc = {
  SETPCAP: 'Изменение набора привилегий процесса.',
  MKNOD: 'Создание специальных файлов через mknod(2).',
  AUDIT_WRITE: 'Запись сообщений в журнал аудита ядра.',
  CHOWN: 'Произвольное изменение UID и GID владельца файлов (см. chown(2)).',
  NET_RAW: 'Использование сокетов RAW и PACKET.',
  DAC_OVERRIDE: 'Обход проверок прав на чтение, запись и выполнение файлов.',
  FOWNER: 'Обход проверок прав для операций, которые обычно требуют совпадения UID процесса с UID файла.',
  FSETID: 'Сохранение битов set-user-ID и set-group-ID при изменении файла.',
  KILL: 'Обход проверок прав при отправке сигналов.',
  SETGID: 'Произвольное изменение GID процесса и списка дополнительных групп.',
  SETUID: 'Произвольное изменение UID процесса.',
  NET_BIND_SERVICE: 'Привязка сокета к привилегированным портам (номер порта меньше 1024).',
  SYS_CHROOT: 'Использование chroot(2), смена корневого каталога.',
  SETFCAP: 'Назначение привилегий файлам.',
  SYS_MODULE: 'Загрузка и выгрузка модулей ядра.',
  SYS_RAWIO: 'Операции с портами ввода-вывода (iopl(2) и ioperm(2)).',
  SYS_PACCT: 'Использование acct(2), включение и выключение учёта процессов.',
  SYS_ADMIN: 'Выполнение широкого набора операций системного администрирования.',
  SYS_NICE: 'Повышение приоритета процесса (nice(2), setpriority(2)) и изменение приоритета произвольных процессов.',
  SYS_RESOURCE: 'Превышение ограничений на ресурсы.',
  SYS_TIME: 'Установка системных часов (settimeofday(2), stime(2), adjtimex(2)) и аппаратных часов реального времени.',
  SYS_TTY_CONFIG: 'Использование vhangup(2) и привилегированных операций ioctl(2) над виртуальными терминалами.',
  AUDIT_CONTROL: 'Включение и выключение аудита ядра, изменение правил фильтрации, получение состояния аудита.',
  MAC_ADMIN: 'Изменение конфигурации и состояния мандатного контроля доступа (MAC). Реализовано в модуле Smack.',
  MAC_OVERRIDE: 'Обход мандатного контроля доступа (MAC). Реализовано в модуле безопасности Smack (LSM).',
  NET_ADMIN: 'Выполнение различных операций по настройке сети.',
  SYSLOG: 'Выполнение привилегированных операций syslog(2).',
  DAC_READ_SEARCH: 'Обход проверок прав на чтение файлов, а также на чтение и обход каталогов.',
  LINUX_IMMUTABLE: 'Установка флагов inode FS_APPEND_FL и FS_IMMUTABLE_FL.',
  NET_BROADCAST: 'Широковещательная рассылка через сокеты и приём многоадресных сообщений.',
  IPC_LOCK: 'Блокировка памяти (mlock(2), mlockall(2), mmap(2), shmctl(2)).',
  IPC_OWNER: 'Обход проверок прав для операций над объектами IPC System V.',
  SYS_PTRACE: 'Трассировка произвольных процессов через ptrace(2).',
  SYS_BOOT: 'Использование reboot(2) и kexec_load(2): перезагрузка и загрузка нового ядра.',
  LEASE: 'Установка аренды (lease) на произвольные файлы (см. fcntl(2)).',
  WAKE_ALARM: 'Инициирование выхода системы из спящего режима.',
  BLOCK_SUSPEND: 'Использование средств, блокирующих переход системы в спящий режим.',
};

export function ContainerCapabilities() {
  // all capabilities can be found at https://docs.docker.com/engine/reference/run/#runtime-privilege-and-linux-capabilities
  return [
    new ContainerCapability('SETPCAP', true),
    new ContainerCapability('MKNOD', true),
    new ContainerCapability('AUDIT_WRITE', true),
    new ContainerCapability('CHOWN', true),
    new ContainerCapability('NET_RAW', true),
    new ContainerCapability('DAC_OVERRIDE', true),
    new ContainerCapability('FOWNER', true),
    new ContainerCapability('FSETID', true),
    new ContainerCapability('KILL', true),
    new ContainerCapability('SETGID', true),
    new ContainerCapability('SETUID', true),
    new ContainerCapability('NET_BIND_SERVICE', true),
    new ContainerCapability('SYS_CHROOT', true),
    new ContainerCapability('SETFCAP', true),
    new ContainerCapability('SYS_MODULE', false),
    new ContainerCapability('SYS_RAWIO', false),
    new ContainerCapability('SYS_PACCT', false),
    new ContainerCapability('SYS_ADMIN', false),
    new ContainerCapability('SYS_NICE', false),
    new ContainerCapability('SYS_RESOURCE', false),
    new ContainerCapability('SYS_TIME', false),
    new ContainerCapability('SYS_TTY_CONFIG', false),
    new ContainerCapability('AUDIT_CONTROL', false),
    new ContainerCapability('MAC_ADMIN', false),
    new ContainerCapability('MAC_OVERRIDE', false),
    new ContainerCapability('NET_ADMIN', false),
    new ContainerCapability('SYSLOG', false),
    new ContainerCapability('DAC_READ_SEARCH', false),
    new ContainerCapability('LINUX_IMMUTABLE', false),
    new ContainerCapability('NET_BROADCAST', false),
    new ContainerCapability('IPC_LOCK', false),
    new ContainerCapability('IPC_OWNER', false),
    new ContainerCapability('SYS_PTRACE', false),
    new ContainerCapability('SYS_BOOT', false),
    new ContainerCapability('LEASE', false),
    new ContainerCapability('WAKE_ALARM', false),
    new ContainerCapability('BLOCK_SUSPEND', false),
  ].sort(function (a, b) {
    return a.capability < b.capability ? -1 : 1;
  });
}

export function ContainerCapability(cap, allowed) {
  this.capability = cap;
  this.allowed = allowed;
  this.description = capDesc[cap];
}
